<template>
  <el-form style="background: white" :model="warehousingForm" :rules="rules" ref="ruleForm">
    <el-form-item label="所属项目" prop="projectId">
      <el-select :disabled="_disabled" size="small" v-model="warehousingForm.projectId" filterable placeholder="请选择所属项目">
        <el-option :label="item.projectName" :value="item.projectId" v-for="(item, index) of projectList"
          :key="index"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="入库日期" prop="storageDate">
      <el-date-picker :disabled="_disabled" size="small" v-model="warehousingForm.storageDate" value-format="yyyy-MM-dd" type="date"
        placeholder="请选择入库日期"></el-date-picker>
    </el-form-item>
    <el-form-item label="入库说明" prop="storageExplain">
      <el-input :disabled="_disabled" size="small" type="textarea" maxlength="300" :autosize="{ minRows: 4, maxRows: 8 }"
        v-model="warehousingForm.storageExplain" placeholder="请输入入库说明"></el-input>
    </el-form-item>

    <el-form-item label="入库物料明细" prop="detailedList"></el-form-item>

    <el-table class="global-table material-table" :data="warehousingForm.detailedList">
      <el-table-column label="物料名称" prop="materialName"></el-table-column>
      <el-table-column label="规格型号" prop="specifications"></el-table-column>
      <el-table-column label="品牌名称" prop="brand"></el-table-column>
      <el-table-column label="物料分类" prop="materialTypeName"></el-table-column>
      <el-table-column label="单价（元）" prop="unitPrice" width="200px">
        <template v-slot="{ row, $index }">
          <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.unitPrice'" :rules='rules.unitPrice'>
            <el-input :disabled="_disabled" maxlength="30" v-model="row.unitPrice" placeholder="请输入"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="单位" prop="company"></el-table-column>
      <el-table-column label="供应商名称" prop="supplierName"></el-table-column>
      <el-table-column prop="operationStock" width="200px">
        <template slot="header">
            <span style="color: #f00;font-size: 14px;margin-right: 4px;">*</span>入库数量
        </template>
        <template v-slot="{ row, $index }">
          <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.operationStock'"
            :rules='rules.operationStock'>
            <el-input :disabled="_disabled" maxlength="30" v-model="row.operationStock" placeholder="请输入"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column prop="warehouseName" width="200px">
        <template slot="header">
            <span style="color: #f00;font-size: 14px;margin-right: 4px;">*</span>入库仓库
        </template>
        <template v-slot="{ row, $index }">
          <el-form-item label-width="'0'" :prop="'detailedList.' + $index + '.warehouseId'"
            :rules='rules.warehouseId'>
            <el-select :disabled="_disabled" v-model="row.warehouseId" placeholder="请选择">
              <el-option v-for="item in warehouseData" :key="item.warehouseId" :label="item.warehouseName"
                :value="item.warehouseId"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column v-if="!_disabled" label="操作" prop="">
        <template v-slot="{ $index }">
          <el-button class="del-btn" type="text" @click="deleteDetailedList($index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-button v-if="!_disabled" type="text" class="mt10" icon="el-icon-plus" @click="addMaterial">新增入库物料</el-button>

    <el-dialog title="物料清单" :visible.sync="dialogVisible" :modal-append-to-body="false"
  :append-to-body="true" width="800px" :close-on-click-modal="false">
      <el-form class="global-form" inline label-width="100px">
        <el-form-item prop="materialName">
          <el-input v-model="searchForm.materialName" clearable placeholder="请输入物料名称"></el-input>
        </el-form-item>
        <el-form-item prop="materialTypeId">
          <el-cascader v-model="searchForm.materialTypeId" :options="materialTypeData"
            :props="{ checkStrictly: true, emitPath: false, children: 'childNode', label: 'materialTypeName', value: 'materialTypeId' }"
            placeholder="请选择物料分类" clearable></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.supplierId" clearable placeholder="供应商名称">
            <el-option v-for="item in supplierData" :key="item.supplierId" :label="item.supplierName"
              :value="item.supplierId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearchWorkOrder">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="table" @selection-change="selectionLineChangeHandle" class="global-table" reserve-selection=true
        :row-key="getRowKeys" :data="materialData">
        <el-table-column reserve-selection type="selection" :selectable="selectable"></el-table-column>
        <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="specifications" label="规格型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brand" label="品牌名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="company" label="单位" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialTypeName" label="物料分类" show-overflow-tooltip></el-table-column>
        <el-table-column prop="supplierName" label="供应商名称" show-overflow-tooltip></el-table-column>
      </el-table>

      <global-pagination @size-change="getMaterialData" @current-change="getMaterialData" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
    </el-dialog>
  </el-form>
</template>
<script>
//用来进行测试外部表单组件的vue表单，不需要的话可以删除
import OuterFormMixin from './OuterFormMixin'

const operationStockV = (rule, value, callback) => {
  const reg = /^[1-9][0-9]*$/
  if (!reg.test(value) || Number(value) > 9999999) {
    return callback(new Error('请输入1到9999999整数'))
  } else {
    return callback()
  }
}
const unitPriceV = (rule, value, callback) => {
  if ((value && !Number(value)) || (value && (value > 9999999.9 || value < 0.1))) {
    return callback(new Error('单价为0.1到9999999.9的数字'))
  } else {
    return callback()
  }
}
export default {
  name: "WarehousingHwnysForm",
  mixins: [OuterFormMixin],
  data(){
    return {
      disabled: false,
      warehousingForm: {
        projectId: '',
        storageDate: '',
        storageExplain: '',
        imgList: [],
        fileList: [],
        detailedList: []
      },
      rules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: 'blur' }
        ],
        storageDate: [
          { required: true, message: '请选择入库日期', trigger: 'blur' }
        ],
        detailedList: [
          { required: true, message: '请添加入库物料明细', trigger: 'change' }
        ],
        operationStock: [
          { required: true, message: '请输入入库数量', trigger: 'change' },
          { validator: operationStockV, trigger: ['blur', 'change'] }
        ],
        warehouseId: [
          { required: true, message: '请选择入库仓库', trigger: 'change' }
        ],
        unitPrice: [
          { validator: unitPriceV, trigger: ['blur', 'change'] }
        ]
      },
      dialogVisible: false, // 物料清单
      searchForm: { // 物料清单
        materialName: '', // 产品名称
        materialTypeId: '', // 物料分类
        supplierId: '' // 供应商
      },
      materialData: [], // 物料列表
      warehouseData: [], // 仓库列表
      materialTypeData: [], // 物料类型
      supplierData: [], // 供应商类型
      page: 1,
      size: 10,
      total: 0,
      selectItems: [], // 临时选中的物料
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {
    'warehousingForm.projectId'() {

      if (this.warehousingForm.detailedList && !this._disabled) {
        // 清空所有行的仓库ID
        this.warehousingForm.detailedList.forEach((item) => {
          item.warehouseId = ''
        });

        // 手动清除仓库字段的验证状态
        this.$nextTick(() => {
          this.warehousingForm.detailedList.forEach((_, index) => {
            this.$refs.ruleForm.clearValidate(`detailedList.${index}.warehouseId`);
          });
        });
      }

      // 获取新项目的仓库列表
      this.$axios.get(this.$apis.material.selectYhWarehouseByList, {
        projectId: this.warehousingForm.projectId
      }).then(res => {
        this.warehouseData = res.list || []
      });
    }
  },
  mounted() {
    this.formInit(this.warehousingForm, 'ruleForm')
    this.loadMaterialType() // 物料类型
    this.loadSupplierType() // 加载供应商
  },
  methods: {
    // 物料类型
    loadMaterialType() {
      this.$axios.get(this.$apis.material.selectYhMaterialTypeByList).then(res => {
        this.materialTypeData = res || []
      })
    },
    // 加载供应商
    loadSupplierType() {
      this.$axios.get(this.$apis.material.selectYhSupplierByPage).then(res => {
        this.supplierData = res.list || []
      })
    },
    // 获取物料
    getMaterialData() {
      this.$axios.get(this.$apis.material.selectYhMaterialInfoByPage, {
        ...this.searchForm,
        page: this.page,
        size: this.size,
        isStop: 0 // 启用的
      }).then(res => {
        this.materialData = res.list || []
        this.total = res.total || 0
      })
    },
    addMaterial() {
      if (!this.warehousingForm.projectId) {
        this.$message.warning('请先选择项目')
        return
      }

      if (!this.warehousingForm.detailedList) {
        this.warehousingForm.detailedList = [];
      }

      this.page = 1
      this.searchForm = { // 物料清单
        materialName: '', // 产品名称
        materialTypeId: '', // 物料分类
        supplierId: '' // 供应商
      }
      this.getMaterialData()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.table.clearSelection()
        this.warehousingForm.detailedList.forEach(item => {
          this.$refs.table.toggleRowSelection(item, true)
        })
      })
    },
    deleteDetailedList(index) {
      this.warehousingForm.detailedList.splice(index, 1)
    },
    // 分页
    onSearchWorkOrder() {
      this.page = 1
      this.getMaterialData()
    },
    selectionLineChangeHandle(val) {
      this.selectItems = val
    },
    // 记录选择的物料，翻页不影响
    getRowKeys(row) {
      return row.materialId
    },
    // 勾选物料
    confirm() {
      let arr = []
      arr = this.selectItems.filter((item) => {
        return this.warehousingForm.detailedList.every((k) => {
          return item.materialId !== k.materialId
        })
      })

      for(var i in arr){
        if(this.warehousingForm.detailedList.some(item => item.materialId == arr[i].materialId)){
          this.$message.warning('每种物料只能选择一次!')
          return
        }
      }

      this.warehousingForm.detailedList = [...this.warehousingForm.detailedList, ...arr]
      this.dialogVisible = false
    },
    selectable(row) {
      return !this.warehousingForm.detailedList.some((item) => item.materialId === row.materialId)
    },
  }
}
</script>
<style scoped lang="less">
::v-deep .material-table {

    .el-input,
    .el-select,
    .el-cascader {
      width: 100% !important;
    }

    .el-form-item {
      margin-bottom: 0
    }

    ;

    .el-form-item--small.el-form-item {
      margin-bottom: 0
    }

    .cell {
      height: 62px;
      display: flex;
      align-items: center
    }
  }
</style>
